import logo from './logo.svg';
import './App.css';
import ListeRepas from "./ListeRepas";



export default App;
function App() {
  return (
    <div>
      <ListeRepas />
    </div>
  );
}


